export default __webpack_public_path__ + "static/media/choose-product.cc2758e1.svg";